const parseStringToArray = (text) => (text ?? '')
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
const isStringOverlapping = (string1, string2) => {
    const array1 = parseStringToArray(string1);
    const array2 = parseStringToArray(string2);
    return array1.some((item) => array2.includes(item));
};
export { parseStringToArray, isStringOverlapping };
